// extracted by mini-css-extract-plugin
export default {"sticky":"menu_sticky__IY0hB","container":"menu_container__NRqNO","menu__box":"menu_menu__box__8c09i","title":"menu_title__bgRd0"};